module.exports = __webpack_public_path__ + "static/media/eu_verdadeiro_6.437ca5ac.jpg";